import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSnackbar } from 'notistack';
import { TimekeeperService } from 'services/TimekeeperService';
import { TipoAcumulacionEnum } from 'repository/timekeeper/@types/TypeAccrualEnum';
import { AccrualCode } from 'repository/timekeeper/@types/AccrualCode';
import { FormAccrualCode } from './FormAccrualCode';
import { FormValues } from 'schemas/AccrualCode';
import { toIsoDurationFromHourMinute } from 'utils/Duration';


interface UpdateProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  rows: any;
  rowToEdit: AccrualCode;
  reloading: () => void;
}

const timekeeperService = new TimekeeperService();

export const UpdateAccrualCode: FC<UpdateProps> = ({ open, setOpen, rows, rowToEdit, reloading }) => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  const handleSubmit = async (values: FormValues) => {
    const payload: AccrualCode = {
      ...rowToEdit,
      name: values.name,
      abbreviation: values.abbreviation,
      type_accrual: values.type_accrual,
      hour_per_day:
        values.type_accrual === TipoAcumulacionEnum.DIAS
          ? toIsoDurationFromHourMinute(values.hour_per_day as string)
          : undefined,
      allow_manual_edits: values.allow_manual_edits,
      show_code: values.show_code,
    } as AccrualCode;
    try {
      await timekeeperService.accrual_code.update(payload.id, payload);
      enqueueSnackbar(t('accruals.accrual_codes.dialog.alerts.update.success'), { variant: 'success' });
      reloading();
    } catch (error) {
      console.error(error);
      enqueueSnackbar(t('accruals.accrual_codes.dialog.alerts.update.error'), { variant: 'error' });
      throw error;
    }
  };

  return (
    <FormAccrualCode
      open={open}
      setOpen={setOpen}
      rows={rows}
      initialValues={{
        id: (rowToEdit as any)?.id,
        name: rowToEdit?.name,
        abbreviation: rowToEdit?.abbreviation,
        type_accrual: rowToEdit?.type_accrual ?? TipoAcumulacionEnum.HORAS,
        hour_per_day: rowToEdit?.type_accrual === TipoAcumulacionEnum.DIAS ? (rowToEdit?.hour_per_day as string) : undefined,
        allow_manual_edits: rowToEdit?.allow_manual_edits,
        show_code: rowToEdit?.show_code,
      }}
      titleKey={'accruals.accrual_codes.dialog.titles.edit'}
      onSubmit={handleSubmit}
    />
  );
};